module.exports = __webpack_public_path__ + "img/BG_Desktop_Orange.f89f8148.png";